import React from "react";
import {
  FiSearch,
  FiRefreshCw,
  FiMenu,
  FiX,
  FiSun,
  FiMoon,
} from "react-icons/fi";
import {
  ContentHeader,
  DesktopHeader,
  MobileMenuButton,
  PageTitle,
  RefetchButton,
  StatusFilterContainer,
  StatusFilterSelect,
  SearchContainer,
  SearchIcon,
  SearchInput,
  MobileHeaderTop,
  MobileHeaderBottom,
} from "../styles/Layoutstyle";

const Header = ({
  activeView,
  isMobileMenuOpen,
  onMenuToggle,
  onRefetch,
  loading,
  analyticsLoading,
  statusFilter,
  onStatusFilterChange,
  statusesLoading,
  availableStatuses,
  searchTerm,
  onSearchInputChange,
  onSearchSubmit,
  isDarkMode,
  onThemeToggle,
}) => {
  const showOrderControls = !["users", "realflow"].includes(activeView);

  return (
    <ContentHeader>
      <DesktopHeader>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <MobileMenuButton isOpen={isMobileMenuOpen} onClick={onMenuToggle}>
            {isMobileMenuOpen ? <FiX /> : <FiMenu />}
          </MobileMenuButton>
          <PageTitle isDarkMode={isDarkMode}>
            {activeView === "dashboard" && "Dashboard"}
            {activeView === "orders" && "Orders Management"}
            {activeView === "analytics" && "Order Analytics"}
            {activeView === "accuzip" && "Accuzip Automation Queue"}
            {activeView === "users" && "User Management"}
            {activeView === "realflow" && "RealFlow CSVs"}
          </PageTitle>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
          {showOrderControls && (
            <>
              <form onSubmit={onSearchSubmit}>
                <SearchContainer>
                  <SearchIcon>
                    <FiSearch />
                  </SearchIcon>
                  <SearchInput
                    type="text"
                    placeholder="Search orders by ID..."
                    value={searchTerm}
                    onChange={onSearchInputChange}
                    isDarkMode={isDarkMode}
                  />
                </SearchContainer>
              </form>
              <StatusFilterContainer>
                <StatusFilterSelect
                  value={statusFilter}
                  onChange={onStatusFilterChange}
                  disabled={statusesLoading}
                  isDarkMode={isDarkMode}
                >
                  <option value="">All Statuses</option>
                  {availableStatuses?.map((status) => (
                    <option key={status} value={status}>
                      {status.split(/[-_]/).length > 1
                        ? status.split(/[-_]/).slice(1).join("-")
                        : status}
                    </option>
                  ))}
                </StatusFilterSelect>
              </StatusFilterContainer>
            </>
          )}

          <RefetchButton
            onClick={onRefetch}
            disabled={loading || analyticsLoading}
            loading={loading || analyticsLoading}
          >
            <FiRefreshCw />
            Refresh
          </RefetchButton>

          <RefetchButton onClick={onThemeToggle}>
            {isDarkMode ? <FiSun /> : <FiMoon />}
            {isDarkMode ? "Light" : "Dark"}
          </RefetchButton>
        </div>
      </DesktopHeader>

      {/* Mobile Header */}
      <MobileHeaderTop>
        <MobileMenuButton isOpen={isMobileMenuOpen} onClick={onMenuToggle}>
          {isMobileMenuOpen ? <FiX /> : <FiMenu />}
        </MobileMenuButton>
        <PageTitle isDarkMode={isDarkMode}>
          {activeView === "dashboard" && "Dashboard"}
          {activeView === "orders" && "Orders Management"}
          {activeView === "analytics" && "Order Analytics"}
          {activeView === "accuzip" && "Accuzip Automation Queue"}
          {activeView === "realflow" && "RealFlow CSVs"}
        </PageTitle>
      </MobileHeaderTop>

      <MobileHeaderBottom>
        <RefetchButton
          onClick={onRefetch}
          disabled={loading || analyticsLoading}
          loading={loading || analyticsLoading}
        >
          <FiRefreshCw />
          Refresh
        </RefetchButton>

        <RefetchButton onClick={onThemeToggle}>
          {isDarkMode ? <FiSun /> : <FiMoon />}
          {isDarkMode ? "Light" : "Dark"}
        </RefetchButton>

        {showOrderControls && (
          <>
            <StatusFilterContainer>
              <StatusFilterSelect
                value={statusFilter}
                onChange={onStatusFilterChange}
                disabled={statusesLoading}
                isDarkMode={isDarkMode}
              >
                <option value="">All Statuses</option>
                {availableStatuses.map((status) => (
                  <option key={status} value={status}>
                    {status.split(/[-_]/).pop()}
                  </option>
                ))}
              </StatusFilterSelect>
            </StatusFilterContainer>

            <form onSubmit={onSearchSubmit} style={{ flex: "1" }}>
              <SearchContainer>
                <SearchIcon>
                  <FiSearch />
                </SearchIcon>
                <SearchInput
                  type="text"
                  placeholder="Search orders by ID..."
                  value={searchTerm}
                  onChange={onSearchInputChange}
                  isDarkMode={isDarkMode}
                />
              </SearchContainer>
            </form>
          </>
        )}
      </MobileHeaderBottom>
    </ContentHeader>
  );
};

export default Header;
